import script from "./WebhookSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebhookSettings.vue?vue&type=script&setup=true&lang=ts"

import "./WebhookSettings.vue?vue&type=style&index=0&id=fbd9c0f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd9c0f8"]])

export default __exports__